import {
    AssessmentFormQuestionTypeEnum,
    EvaluationQuestionTypeEnum,
    SurveyQuestionTypeEnum,
} from "@genesys/cloud-frontend/models";
import FormType from "enums/FormType";

// the values here are for localization purpose only. They aren't the values stored in Question type.
export enum SubQuestionType {
    MULTIPLE_CHOICE = "multipleChoice",
    YES_OR_NO = "yesOrNo",
    READ_ONLY = "readOnly",
    FREETEXT = "freeText",
    RANGE = "range",
    NPS = "nps",
    MULTIPLE_SELECT = "multipleSelect",
}
export enum QuestionTypesMapSurveyIndex {
    MULTIPLE_CHOICE,
    YES_OR_NO,
    RANGE,
    FREETEXT,
    NPS,
    READ_ONLY,
}

export type QuestionInfoType = {
    subQuestionType: SubQuestionType;
    questionType:
        | EvaluationQuestionTypeEnum
        | SurveyQuestionTypeEnum
        | AssessmentFormQuestionTypeEnum;
};

export const EVALUATION_YES_NO_QUESTION = {
    subQuestionType: SubQuestionType.YES_OR_NO,
    questionType: EvaluationQuestionTypeEnum.MultipleChoiceQuestion,
} as const;

// Define question type configurations
const questionTypesMap = {
    evaluation: [
        {
            subQuestionType: SubQuestionType.MULTIPLE_CHOICE,
            questionType: EvaluationQuestionTypeEnum.MultipleChoiceQuestion,
        },
        EVALUATION_YES_NO_QUESTION,
        {
            subQuestionType: SubQuestionType.RANGE,
            questionType: EvaluationQuestionTypeEnum.MultipleChoiceQuestion,
        },
    ],
    survey: [
        {
            subQuestionType: SubQuestionType.MULTIPLE_CHOICE,
            questionType: SurveyQuestionTypeEnum.MultipleChoiceQuestion,
        },
        {
            subQuestionType: SubQuestionType.YES_OR_NO,
            questionType: SurveyQuestionTypeEnum.MultipleChoiceQuestion,
        },
        {
            subQuestionType: SubQuestionType.RANGE,
            questionType: SurveyQuestionTypeEnum.MultipleChoiceQuestion,
        },
        {
            subQuestionType: SubQuestionType.FREETEXT,
            questionType: SurveyQuestionTypeEnum.FreeTextQuestion,
        },
        {
            subQuestionType: SubQuestionType.NPS,
            questionType: SurveyQuestionTypeEnum.NpsQuestion,
        },
        {
            subQuestionType: SubQuestionType.READ_ONLY,
            questionType: SurveyQuestionTypeEnum.ReadOnlyTextBlockQuestion,
        },
    ],
    assessment: [
        {
            subQuestionType: SubQuestionType.MULTIPLE_CHOICE,
            questionType: AssessmentFormQuestionTypeEnum.MultipleChoiceQuestion,
        },
        {
            subQuestionType: SubQuestionType.YES_OR_NO,
            questionType: AssessmentFormQuestionTypeEnum.MultipleChoiceQuestion,
        },
        {
            subQuestionType: SubQuestionType.FREETEXT,
            questionType: AssessmentFormQuestionTypeEnum.FreeTextQuestion,
        },
    ],
} as const;

// Additional question type for multiple-select
export const MULTIPLE_SELECT_QUESTION = {
    subQuestionType: SubQuestionType.MULTIPLE_SELECT,
    questionType: EvaluationQuestionTypeEnum.MultipleSelectQuestion,
} as const;

/**
 * Returns the question types map based on multiple-select inclusion
 * @param includeMultipleSelect - Flag to include multiple-select question type
 * @returns Record of form types and their question configurations
 */
export const getQuestionTypesMap = (
    includeMultipleSelect = false
): Readonly<Record<FormType, ReadonlyArray<QuestionInfoType>>> => {
    if (!includeMultipleSelect) {
        return questionTypesMap;
    }

    return {
        ...questionTypesMap,
        evaluation: [...questionTypesMap.evaluation, MULTIPLE_SELECT_QUESTION],
    };
};
